import React from "react";
import PropTypes from "prop-types";
import Util from "../../../common/util";

function AngelInvestmentTrend(props) {
  const { investmentTrend } = props;

  return (
    <React.Fragment>
      { investmentTrend && (
        <div className='row'>
          <div className='col-sm-4'>
            <h3 className='pb-2'>投資サイズ</h3>
          </div>
          <div className='col-sm-8'>
            <p>
              {Util.newLineToBrTag(investmentTrend)}
            </p>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

AngelInvestmentTrend.propTypes = {
  investmentTrend: PropTypes.string
};

AngelInvestmentTrend.defaultProps = {
  investmentTrend: null
};

export default AngelInvestmentTrend;
